module.exports = __webpack_public_path__ + "media/images/global/menu/menu-adcfe0fb7ca89ba573e71f13e3fb1dd6.svg";